/* Hang Dry: the line. Finds the top edge of the item in each photo and moves the clothespins onto it.
   Reads a small copy of the photo (data-probe), treats the corner color as background, and traces the
   item's top edge. Two pins land on the shoulders (30% and 70% across the item), one pin on the highest
   point near the middle (strap, brim, top of the paper). Flipped items (caps) are traced upside down.
   If the photo can't be read, the starting spots from hd-hang-cfg.liquid stay.
   With data-cut, the photo background is also removed (flood fill from the edges) so only the
   product hangs, over any page background. Until then, or if it fails, the photo is multiplied in. */
(function () {
  function cutout(g, im) {
    var img = g.querySelector('.hd-hang__img');
    if (!img) return;
    var want = g.getAttribute('data-probe');
    var W = Math.min(im.naturalWidth, 1400), H = Math.round(W * im.naturalHeight / im.naturalWidth);
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, W, H);
    var id = x.getImageData(0, 0, W, H), d = id.data, n = W * H;
    var corner = function (cx, cy) { var k = (cy * W + cx) * 4; return [d[k], d[k + 1], d[k + 2], d[k + 3]]; };
    var cs = [corner(2, 2), corner(W - 3, 2), corner(2, H - 3), corner(W - 3, H - 3)];
    if (cs.every(function (p) { return p[3] < 20; })) { g.classList.add('is-cut'); return; }
    var bg = [0, 1, 2].map(function (m) { return cs.reduce(function (s, p) { return s + p[m] / 4; }, 0); });
    var diff = new Uint16Array(n), k, i;
    for (i = 0; i < n; i++) { k = i * 4; diff[i] = Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]); }
    var T = 26, T2 = 64, seen = new Uint8Array(n), stack = [];
    for (i = 0; i < W; i++) { stack.push(i, (H - 1) * W + i); }
    for (i = 0; i < H; i++) { stack.push(i * W, i * W + W - 1); }
    while (stack.length) {
      var q = stack.pop();
      if (seen[q] || diff[q] > T) continue;
      seen[q] = 1;
      var qx = q % W;
      if (qx > 0) stack.push(q - 1);
      if (qx < W - 1) stack.push(q + 1);
      if (q >= W) stack.push(q - W);
      if (q < n - W) stack.push(q + W);
    }
    // Gaps inside the outline (a tote's strap loop): close matches to the background, single pin items only
    if (g.getAttribute('data-pins') === '1' && g.getAttribute('data-flip') !== '1') {
      var hole = new Uint8Array(n), region = [];
      for (i = 0; i < n; i++) {
        if (seen[i] || hole[i] || diff[i] > 12) continue;
        region.length = 0; stack.push(i);
        while (stack.length) {
          var h = stack.pop();
          if (seen[h] || hole[h] || diff[h] > 12) continue;
          hole[h] = 1; region.push(h);
          var hx = h % W;
          if (hx > 0) stack.push(h - 1);
          if (hx < W - 1) stack.push(h + 1);
          if (h >= W) stack.push(h - W);
          if (h < n - W) stack.push(h + W);
        }
        if (region.length > n * 0.002) region.forEach(function (r) { seen[r] = 1; });
      }
    }
    // Hook items (plates): white on a near-white photo, so the fill bites into them. They are solid shapes,
    // so everything between the outermost item pixels of each row and column is kept.
    if (g.getAttribute('data-hook') === '1') {
      var row, a, z;
      for (row = 0; row < H; row++) {
        a = -1; z = -1;
        for (i = 0; i < W; i++) { if (diff[row * W + i] > 8) { if (a < 0) a = i; z = i; } }
        if (a >= 0 && z - a > 2) for (i = a; i <= z; i++) seen[row * W + i] = 0;
      }
      for (i = 0; i < W; i++) {
        a = -1; z = -1;
        for (row = 0; row < H; row++) { if (!seen[row * W + i]) { if (a < 0) a = row; z = row; } }
        if (a >= 0) for (row = a; row <= z; row++) seen[row * W + i] = 0;
      }
    }
    for (i = 0; i < n; i++) {
      if (seen[i]) { d[i * 4 + 3] = 0; continue; }
      var ix = i % W;
      var edge = (ix > 0 && seen[i - 1]) || (ix < W - 1 && seen[i + 1]) || (i >= W && seen[i - W]) || (i < n - W && seen[i + W]);
      if (edge && diff[i] < T2) d[i * 4 + 3] = Math.round(255 * (diff[i] - T) / (T2 - T));
    }
    x.putImageData(id, 0, 0);
    c.toBlob(function (b) {
      if (g.getAttribute('data-probe') !== want) return;
      if (!b) { g.classList.add('cut-off'); return; }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = URL.createObjectURL(b);
      g.classList.add('is-cut');
    }, 'image/png');
  }
  // Product page: size the hanging piece so the item runs from the line down to just above the fold
  function sizeHero(g) {
    var media = g.closest('.hd-pdp-line');
    if (!media || !g.dataset.pb) return;
    var piece = g.parentElement;
    var ar = parseFloat(getComputedStyle(g).getPropertyValue('--ar')) || 1.3333;
    var sc = parseFloat(getComputedStyle(g).getPropertyValue('--sc')) || 1;
    var span = (parseFloat(g.dataset.pb) - parseFloat(g.dataset.py)) * ar * sc;
    if (!(span > 0.1)) return;
    var pageTop = media.getBoundingClientRect().top + window.scrollY;
    // Hook items (plates) hang lower: the hook's drop sits above the item inside the piece
    var pad = parseFloat(getComputedStyle(g).paddingTop) || 0;
    var room = Math.min(window.innerHeight - pageTop, media.clientHeight) - piece.offsetTop - pad - 28;
    var vw = window.innerWidth, wide = vw >= 750;
    var pair = media.classList.contains('hd-pdp-line--pair');
    if (!wide) {
      // Phones: a fixed share of the width, and the hero ends just under the piece (the longer one, front and back)
      var gm = vw * (pair ? 0.44 : 0.7);
      g.style.setProperty('--gw', Math.round(gm) + 'px');
      var h = Math.round(piece.offsetTop + pad + gm * span + 40);
      if (h > (parseFloat(media.dataset.hh) || 0)) {
        media.dataset.hh = h;
        media.style.setProperty('height', h + 'px', 'important');
      }
      return;
    }
    media.style.removeProperty('height');
    var max = Math.min(vw * (pair ? 0.26 : 0.5), 2 * (vw * 0.64 - 492));
    // Two views (front and back, front and side): both hang at the same size, the smaller of what each fits
    if (pair) {
      var fitSpan = sc > 1 ? span / sc : span; // a view sized up in the theme editor does not shrink the pair
      var gwp = Math.min(parseFloat(media.dataset.gwp) || Infinity, Math.max(160, Math.min(room / fitSpan, max)));
      media.dataset.gwp = gwp;
      media.querySelectorAll('.hd-pdp-line__piece .hd-hang__garment').forEach(function (g2) { g2.style.setProperty('--gw', Math.round(gwp) + 'px'); });
      return;
    }
    // Scaled-down items (caps) stay scaled down here too: less height and less width than a tee
    var gw = Math.max(220, Math.min(room * sc / span, max * sc));
    g.style.setProperty('--gw', Math.round(gw) + 'px');
  }
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { document.querySelectorAll('.hd-pdp-line').forEach(function (m) { delete m.dataset.hh; delete m.dataset.gwp; }); document.querySelectorAll('.hd-pdp-line .hd-hang__garment.is-fit').forEach(sizeHero); }, 150);
  });
  function fit(g) {
    var src = g.getAttribute('data-probe');
    if (!src || g.dataset.fitDone) return;
    g.dataset.fitDone = '1';
    var two = g.getAttribute('data-pins') === '2';
    var flip = g.getAttribute('data-flip') === '1';
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      if (g.getAttribute('data-probe') !== src) return;
      if (g.getAttribute('data-cut') === '1') { try { cutout(g, im); } catch (e) { g.classList.add('cut-off'); } }
      try {
        var W = 120, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d', { willReadFrequently: true });
        if (flip) { x.translate(W, H); x.scale(-1, -1); }
        x.drawImage(im, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data;
        var px = function (i, j) { var k = (j * W + i) * 4; return [d[k], d[k + 1], d[k + 2], d[k + 3]]; };
        var cs = [px(1, 1), px(W - 2, 1), px(1, H - 2), px(W - 2, H - 2)];
        var clear = cs.every(function (p) { return p[3] < 20; });
        var bg = [0, 1, 2].map(function (n) { return cs.reduce(function (s, p) { return s + p[n] / 4; }, 0); });
        var fg = function (i, j) {
          var p = px(i, j);
          if (p[3] < 40) return false;
          if (clear) return true;
          return Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]) > 18;
        };
        var top = [], i, j;
        for (i = 0; i < W; i++) {
          top[i] = -1;
          for (j = 0; j < H; j++) { if (fg(i, j) && (j + 1 >= H || fg(i, j + 1))) { top[i] = j; break; } }
        }
        var L = -1, R = -1;
        for (i = 0; i < W; i++) if (top[i] >= 0) { if (L < 0) L = i; R = i; }
        if (L < 0 || R - L < W * 0.15) return;
        var xs;
        if (two) {
          xs = [L + (R - L) * 0.3, L + (R - L) * 0.7];
        } else {
          var a = Math.round(L + (R - L) * 0.3), b = Math.round(L + (R - L) * 0.7), mid = (L + R) / 2, bi = -1;
          for (i = a; i <= b; i++) {
            if (top[i] < 0) continue;
            if (bi < 0 || top[i] < top[bi] - 1 || (top[i] <= top[bi] + 1 && Math.abs(i - mid) < Math.abs(bi - mid))) bi = i;
          }
          if (bi < 0) return;
          xs = [bi];
        }
        var ys = xs.map(function (v) {
          var m = H, k, i0 = Math.round(v);
          for (k = i0 - 1; k <= i0 + 1; k++) if (top[k] >= 0 && top[k] < m) m = top[k];
          return m;
        });
        var py = ys.reduce(function (s, v) { return s + v; }, 0) / ys.length / H + 0.012;
        if (!(py > 0 && py < 0.8)) return;
        g.style.setProperty('--py', py.toFixed(4));
        g.style.setProperty('--p1x', (xs[0] / W).toFixed(4));
        if (xs[1] != null) g.style.setProperty('--p2x', (xs[1] / W).toFixed(4));
        var pb = 0;
        for (i = L; i <= R; i++) { if (top[i] < 0) continue; for (j = H - 1; j > top[i]; j--) { if (fg(i, j)) { if (j > pb) pb = j; break; } } }
        g.dataset.py = py; g.dataset.pb = pb / H;
        g.classList.add('is-fit');
        sizeHero(g);
      } catch (e) {}
    };
    im.onerror = function () { g.classList.add('cut-off'); };
    // Never leave a piece hidden: show the plain photo if the cutout hasn't landed in 5s
    setTimeout(function () { if (g.getAttribute('data-probe') === src && !g.classList.contains('is-cut')) g.classList.add('cut-off'); }, 5000);
    im.src = src;
  }
  // Product page: variants with their own photo (data-vimg) swap the piece on the line when picked
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-hd2-size]')) return;
    document.querySelectorAll('.hd-pdp-line .hd-hang__garment[data-vimg]').forEach(function (g) {
      var map;
      try { map = JSON.parse(g.getAttribute('data-vimg')); } catch (x) { return; }
      var u = map[t.value], img = g.querySelector('.hd-hang__img');
      if (!u || !img || g.getAttribute('data-probe') === u) return;
      g.classList.remove('is-cut', 'cut-off', 'is-fit');
      delete g.dataset.fitDone;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      // Same URL as the cutout reads: request it with CORS too, or Safari reuses a response the canvas can't read
      img.crossOrigin = 'anonymous';
      img.src = u;
      g.setAttribute('data-probe', u);
      fit(g);
    });
  });
  // Product page: header stays clear over the sky until the sky has scrolled past it; --hd-hdr is its height
  var hdrH = 140;
  function headerHeight() {
    var h = document.querySelector('.section-header');
    if (h) { hdrH = h.offsetHeight; document.documentElement.style.setProperty('--hd-hdr', hdrH + 'px'); }
  }
  function navState() {
    var hero = document.querySelector('.hd-pdp-line');
    if (!hero) return;
    document.body.classList.toggle('hd-nav-solid', hero.getBoundingClientRect().bottom <= hdrH);
  }
  if (document.querySelector('.hd-pdp-line')) {
    headerHeight(); navState();
    window.addEventListener('scroll', navState, { passive: true });
    window.addEventListener('resize', headerHeight);
  }
  // Home page: the header goes see-through while it sits over the sky of the line
  function skyState() {
    var on = false;
    document.querySelectorAll('.hd-rack--photo').forEach(function (s) { var r = s.getBoundingClientRect(); if (r.top < hdrH && r.bottom > 0) on = true; });
    document.body.classList.toggle('hd-over-sky', on);
  }
  if (document.querySelector('.hd-rack--photo')) {
    headerHeight(); skyState();
    window.addEventListener('scroll', skyState, { passive: true });
    window.addEventListener('resize', function () { headerHeight(); skyState(); });
  }
  // Quick add on the line: the panel takes the name tag's place right under its piece (the tag and the + step
  // aside while it is open). It only drops lower if a neighbouring piece hangs into that spot, and the line
  // only grows if the panel would reach the next line.
  function placeQA(panel) {
    var card = panel.closest('.hd-hang'), row = panel.closest('.hd-rack__row');
    if (!card || !row) return;
    var trig = card.querySelector('.hd-col__quickadd-trigger'), tag = card.querySelector('.hd-hang__tag');
    row.style.paddingBottom = '';
    panel.style.top = '';
    if (trig) trig.style.visibility = '';
    if (panel.hidden) return;
    if (trig) trig.style.visibility = 'hidden';
    var pr = panel.getBoundingClientRect(), cr = card.getBoundingClientRect();
    var low = tag ? tag.getBoundingClientRect().top : cr.bottom + 12;
    row.querySelectorAll('.hd-hang').forEach(function (h) {
      if (h === card) return;
      var im = h.querySelector('.hd-hang__img');
      if (!im) return;
      var r = im.getBoundingClientRect();
      if (r.right > pr.left && r.left < pr.right && r.bottom + 12 > low) low = r.bottom + 12;
    });
    var top = low - cr.top;
    panel.style.top = Math.round(top) + 'px';
    var next = row.nextElementSibling;
    if (next) {
      var over = cr.top + top + panel.offsetHeight + 16 - next.getBoundingClientRect().top;
      if (over > 0) row.style.paddingBottom = Math.round(over) + 'px';
    }
  }
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      list.forEach(function (m) { if (m.target.classList && m.target.classList.contains('hd-col__quickadd') && m.target.closest('.hd-rack__row')) placeQA(m.target); });
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
  }
  // Only pieces on screen: the line has a desktop and a phone layout, and the hidden one waits for a resize
  function init() {
    document.querySelectorAll('.hd-hang__garment[data-probe]').forEach(function (g) { if (g.getClientRects().length) fit(g); });
  }
  var ri;
  window.addEventListener('resize', function () { clearTimeout(ri); ri = setTimeout(init, 200); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();